import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49785b04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header px-5 py-4 bg-white" }
const _hoisted_2 = { class: "w-100 list-boxes min-h-300px" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "dual-list list-left col-sm-6" }
const _hoisted_5 = { class: "well text-right" }
const _hoisted_6 = { class: "d-flex align-items-center mb-2" }
const _hoisted_7 = { class: "flex-grow-1 me-2" }
const _hoisted_8 = { class: "col-md-12 list-group my-3 p-4" }
const _hoisted_9 = { class: "d-flex align-items-center position-relative mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid margin-left-select margin-bottom-select"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-gray-800 fs-6 margin-left-select" }, "Select All ", -1))
const _hoisted_15 = {
  key: 1,
  class: "d-flex justify-content-center fw-bold text-muted"
}
const _hoisted_16 = { class: "d-flex align-items-center bg-light-info rounded p-4 mb-3 cursor-move" }
const _hoisted_17 = { class: "form-check form-check-custom me-5" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "fw-bold text-gray-800 fs-6" }
const _hoisted_22 = { class: "list-arrows" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  group: "people",
  "item-key": "id"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-stars text-primary fs-2 me-3 mt-1" }, null, -1))
const _hoisted_28 = { class: "flex-grow-1 me-2" }
const _hoisted_29 = { class: "fw-bold text-gray-800 fs-6" }
const _hoisted_30 = { class: "list-arrows" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "dual-list list-right col-md-6" }
const _hoisted_35 = { class: "well" }
const _hoisted_36 = { class: "d-flex align-items-center mb-2" }
const _hoisted_37 = { class: "flex-grow-1 me-2" }
const _hoisted_38 = { class: "col-md-12 list-group my-3 p-4" }
const _hoisted_39 = { class: "d-flex align-items-center position-relative mb-4" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid margin-left-select margin-bottom-select"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-gray-800 fs-6 margin-left-select" }, "Select All ", -1))
const _hoisted_44 = {
  key: 1,
  class: "d-flex justify-content-center fw-bold text-muted"
}
const _hoisted_45 = { class: "d-flex align-items-center bg-light-success rounded p-4 mb-3 cursor-move" }
const _hoisted_46 = { class: "form-check form-check-custom me-5" }
const _hoisted_47 = ["value"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "fw-bold text-gray-800 fs-6" }
const _hoisted_51 = { class: "list-arrows min-w-80px" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-link fs-6" }, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 3,
  class: "min-h-100px",
  group: "people",
  "item-key": "id"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-stars text-primary fs-2 me-3 mt-1" }, null, -1))
const _hoisted_61 = { class: "flex-grow-1 me-2" }
const _hoisted_62 = { class: "fw-bold text-gray-800 fs-6" }
const _hoisted_63 = { class: "list-arrows" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_FormSectionModal = _resolveComponent("FormSectionModal")!
  const _component_AddEditModal = _resolveComponent("AddEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.t("pages.form.availableSections")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "svg-icon svg-icon-1 position-absolute ms-3",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getAllFormSections && _ctx.getAllFormSections(...args)))
                }, _hoisted_11),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "data-kt-user-table-filter": "search",
                  class: "form-control ps-13 mb-2 mb-sm-0",
                  placeholder: _ctx.t('common.search'),
                  onKeyup: _cache[1] || (_cache[1] = 
                    () => {
                      if (
                        _ctx.searchTermSections.length == 0 ||
                        _ctx.searchTermSections.length >= 3
                      )
                        _ctx.getAllFormSections();
                    }
                  ),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTermSections) = $event))
                }, null, 40, _hoisted_12), [
                  [_vModelText, _ctx.searchTermSections]
                ])
              ]),
              (
                  _ctx.hasPermission('VYZOR:TEMPLATES:FORMS:CREATE') &&
                  _ctx.filteredSections.length > 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.moveAllForward) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.moveAllForward]
                    ]),
                    _hoisted_14
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.t("common.noData")), 1)),
              (_ctx.hasPermission('VYZOR:TEMPLATES:FORMS:CREATE'))
                ? (_openBlock(), _createBlock(_component_draggable, {
                    key: 2,
                    class: "dragArea",
                    list: _ctx.filteredSections,
                    group: "people",
                    "item-key": "id",
                    onChange: _ctx.changeAvailableSection
                  }, {
                    item: _withCtx(({ element }) => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: element.webId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sectionMoveSelected) = $event))
                          }, null, 8, _hoisted_18), [
                            [_vModelCheckbox, _ctx.sectionMoveSelected]
                          ])
                        ]),
                        _createElementVNode("i", {
                          class: "bi bi-list-stars text-primary fs-2 me-3 mt-1",
                          onClick: ($event: any) => (_ctx.addToSelectionMove(element.webId))
                        }, null, 8, _hoisted_19),
                        _createElementVNode("div", {
                          class: "flex-grow-1 me-2",
                          onClick: ($event: any) => (_ctx.addToSelectionMove(element.webId))
                        }, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(element.name), 1)
                        ], 8, _hoisted_20),
                        _createElementVNode("span", _hoisted_22, [
                          _createElementVNode("a", {
                            class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                            onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(element)), ["stop"])
                          }, _hoisted_25, 8, _hoisted_23)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["list", "onChange"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSections, (element, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "d-flex align-items-center bg-light-info rounded p-4 mb-3 cursor-move"
                      }, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(element.name), 1)
                        ]),
                        _createElementVNode("span", _hoisted_30, [
                          _createElementVNode("a", {
                            class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                            onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(element)), ["stop"])
                          }, _hoisted_33, 8, _hoisted_31)
                        ])
                      ]))
                    }), 128))
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.t("pages.form.selectedSections")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "data-kt-user-table-filter": "search",
                  class: "form-control ps-13 mb-2 mb-sm-0",
                  placeholder: _ctx.t('common.search'),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchSections) = $event))
                }, null, 8, _hoisted_41), [
                  [_vModelText, _ctx.searchSections]
                ])
              ]),
              (
                  _ctx.hasPermission('VYZOR:TEMPLATES:FORMS:CREATE') &&
                  _ctx.list1.length > 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.moveAllBackward) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.moveAllBackward]
                    ]),
                    _hoisted_43
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.t("common.noData")), 1)),
              (_ctx.hasPermission('VYZOR:TEMPLATES:FORMS:CREATE'))
                ? (_openBlock(), _createBlock(_component_draggable, {
                    key: 2,
                    class: "dragArea",
                    list: _ctx.filteredSelectedSections,
                    group: "people",
                    "item-key": "id",
                    onChange: _ctx.moveBack
                  }, {
                    item: _withCtx(({ element }) => [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: element.webId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sectionBackSelected) = $event)),
                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, _hoisted_47), [
                            [_vModelCheckbox, _ctx.sectionBackSelected]
                          ])
                        ]),
                        _createElementVNode("i", {
                          class: "bi bi-list-stars text-primary fs-2 me-3 mt-1",
                          onClick: ($event: any) => (_ctx.addBackSelectionMove(element.webId))
                        }, null, 8, _hoisted_48),
                        _createElementVNode("div", {
                          class: "flex-grow-1 me-2",
                          onClick: ($event: any) => (_ctx.addBackSelectionMove(element.webId))
                        }, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(element.sectionName) + "[" + _toDisplayString(element.locationName) + "] ", 1)
                        ], 8, _hoisted_49),
                        _createElementVNode("span", _hoisted_51, [
                          _createElementVNode("span", {
                            class: "text-truncate me-3",
                            innerHTML: 
                          _ctx.format.yesNoToIconPlain(element.locationRestriction)
                        
                          }, null, 8, _hoisted_52),
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: "Assign Location",
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                onClick: _withModifiers(($event: any) => (_ctx.openLocationModal(element)), ["stop"])
                              }, _hoisted_55, 8, _hoisted_53)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("a", {
                            class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                            onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(element)), ["stop"])
                          }, _hoisted_58, 8, _hoisted_56)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["list", "onChange"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSelectedSections, (element, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "d-flex align-items-center bg-light-info rounded p-4 mb-3 cursor-move"
                      }, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("span", _hoisted_62, _toDisplayString(element.name), 1)
                        ]),
                        _createElementVNode("span", _hoisted_63, [
                          _createElementVNode("span", {
                            class: "text-truncate me-3",
                            innerHTML: 
                          _ctx.format.yesNoToIconPlain(element.locationRestriction)
                        
                          }, null, 8, _hoisted_64),
                          _createElementVNode("a", {
                            class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                            onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(element)), ["stop"])
                          }, _hoisted_67, 8, _hoisted_65)
                        ])
                      ]))
                    }), 128))
                  ]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_FormSectionModal, {
      viewName: "form_section_modal",
      data: _ctx.selectedSection,
      loading: _ctx.sectionLoading,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "loading", "showDialog"]),
    _createVNode(_component_AddEditModal, {
      viewName: "add_edit_form_section_location_modal",
      modelValue: _ctx.showAddLocationModal,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showAddLocationModal) = $event)),
      data: _ctx.computedUserSiteModalData,
      onOnClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showAddLocationModal = false)),
      onOnSubmit: _ctx.submitFormLocation,
      onOnCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAddLocationModal = false)),
      onOnSiteChange: _ctx.handleSiteChange
    }, null, 8, ["modelValue", "data", "onOnSubmit", "onOnSiteChange"])
  ]))
}